import React, { createContext, useContext, useState } from 'react';

// Create a context to manage the authentication state
const AuthContext = createContext();

// Create a provider component to wrap your application
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  // Function to set the authenticated user
  const login = (userData) => {
    setUser(userData);
  };

  // Function to log the user out
  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// Create a custom hook to access the authentication context
export function useAuth() {
  return useContext(AuthContext);
}
